import React from "react";
import { APP_PREFIX_PATH } from "configs/AppConfig";

export const requestApprovalRoutes = [
	{
		key: "request-approval",
		exact: true,
		path: `${APP_PREFIX_PATH}/request-approval/list`,
		component: React.lazy(() => import("views/app-views/requests/request-approvals/pages/ApprovalsList")),
	},
	{
		key: "request-on-behalf",
		exact: true,
		path: `${APP_PREFIX_PATH}/on-behalf-request/create`,
		component: React.lazy(() => import("views/app-views/requests/request-approvals/pages/OnBehalf")),
	}
];
